import { useEndpoint } from 'api/useEndpoint';

/** Get the header endpoint.
 *
 * > Note: SUG uses a language code in the URL, so this has to be a hook.
 */
export const useEndpointHeader = () => useEndpoint('/headerContent');
